
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contest/[slug]",
      function () {
        return require("private-next-pages/contest/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contest/[slug]"])
      });
    }
  